<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Supplier Account',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Supplier Contact
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-pencil" tooltip="Edit" @click="handleEdit" v-if="hasPermission(perm.supplier_contact.update)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierContact :value="data" v-if="!loading"/>
                </v-sheet>
            </v-col>
        </v-row>
        <LoadingOverlay v-model="loading"/>
    </v-container>
   
</template>

<script>
import permissions from './../../data/permissions';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue';
import SupplierContact  from "./../../components/purchase/SupplierContact.vue"
import PIconBtn from '../../components/common/PIconBtn.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "SupplierContactDispalyView",
    components: {
        PIconBtn,
        SupplierContact,
        LoadingOverlay
    },
    data() {
        return {
            id: null,
            data: null,
            loading: true,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplierContact/findByID",
            snackbar: "ui/snackbar/show"
        }),
        handleEdit() {
            this.$router.push({ name: "SupplierContactEdit", params: { id : this.id} })
        },
        fetchSupplierContact() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
            }).catch((error) => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar( {text: message, color: "error"} )
            }).finally(() => {
                this.loading = false 
            })
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.fetchSupplierContact()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchSupplierContact();
        next()
    }
}
</script>

<style>

</style>